import React, {
  useState,
  useEffect,
} from 'react';

import { uniqueId } from 'lodash';
import Markdown from 'react-markdown';

import {
  sorter,
  filtration,
} from './Utils';

import {
  HOOKS_URL,
} from './config';

import Search from './Search';
import HookLink from './HookLink';
import VersionDisplay from './VersionDisplay';
import OpenNewTab from './OpenNewTab';
import WebinistaLogo from './WebinistaLogo';

const App = () => {
  const [hooks, setHooks] = useState([]);
  const [sort, setSort] = useState({ by: 'name', ascending: true, hideDeprecated: false });
  const [filtered, setFiltered] = useState([]);
  const [newTab, setNewTab] = useState(false);
  const [version, setVersion] = useState('6.4.3');
  const [updated, setUpdated] = useState(new Date().toUTCString());
  const [q, setQ] = useState(null);
  const [showOnly, setShowOnly] = useState('all');

  // eslint-disable-next-line no-extra-boolean-cast
  const collection = () => ((q || sort.hideDeprecated || showOnly !== 'all') ? filtered : hooks);

  const onChangeNewTab = (domEvent) => setNewTab(domEvent.target.checked);

  const onChanger = (domEvent) => {
    const hDeprecated = domEvent.currentTarget.hide_deprecated.checked;
    const val = domEvent.currentTarget.q.value;
    const show = domEvent.currentTarget.by_type.value;

    setQ(val);
    setShowOnly(show);
    setFiltered(filtration(val, hooks, hDeprecated, show));
    setSort(() => ({ ...sort, hideDeprecated: hDeprecated }));
  }

  const onSubmitter = (domEvent) => {
    domEvent.preventDefault();
  }

  const onSorter = (domEvent) => {
    const action = domEvent.target.dataset.sort;

    setSort((prev) => ({ ...prev, ascending: !prev.ascending }));
    setHooks(sorter(collection(), action, sort.ascending));
  }

  const headers = (obj = []) => {
    if (!obj) return null;
    let tds = [];

    const keys = Object.keys(obj).filter((k) => ['name', 'type', 'description', 'version'].indexOf(k) > -1);

    if (keys.length) {
      tds = keys.map((k) => (
        <th key={uniqueId()}>
          <button
            type="button"
            data-sort={k}
            onClick={onSorter}
          >
            {k}
          </button>
        </th>
      ));
    }

    return (
      <thead>
        <tr>
          {tds}
        </tr>
      </thead>
    )
  }

  /* Loads hooks JSON file from a URL. */
  useEffect(() => {
    if (hooks.length) return;

    const getHooks = async () => {
      const hooks = await fetch(HOOKS_URL, { method: 'GET', mode: 'cors' });
      const json = await hooks.json();
      setHooks(sorter(json.hooks, sort.by, sort.ascending));
      setVersion(json.version);
      setUpdated(json.last_updated);
    }

    // eslint-disable-next-line no-console
    getHooks().catch((e) => console.log(e));

  }, []);

  return (
    <>
      <header>
        <h1>WordPress Hooks</h1>
        <div>
          A browsable, searchable list of WordPress filter and action hooks. Intended for WordPress theme and plugin developers. Not affiliated with the WordPress project or Automattic.
          <OpenNewTab newtab={newTab} onChange={onChangeNewTab} />
        </div>
      </header>

      <main>
        <Search
          onChange={onChanger}
          onSubmit={onSubmitter}
          hideDeprecated={sort.hideDeprecated}
        />
        <div className="table__scrollable">
          <table>
            { headers(hooks[0])}
            <tbody>
              { collection().map((h) => (
                <tr key={uniqueId('hook_')}>
                  <td>
                    <HookLink url={h.url} name={h.name} newtab={newTab} />
                    {h.deprecated && <b className="badge deprecated">deprecated</b> }
                  </td>
                  <td>{h.type}</td>
                  <td><Markdown>{h.description}</Markdown></td>
                  <td>{h.version}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
      <footer>
        <p>
          <a href="#top">Back to top</a>
          <stripe-buy-button
            buy-button-id="buy_btn_1OzrdgDUE3o4CkjNLOFfkGBI"
            publishable-key="pk_live_nTtQOWdIKPTOGhwr8311iytx"
          />
        </p>
        <VersionDisplay version={version} updated={updated} />
        <p id="attribution">
          <WebinistaLogo />
          <i>
            { /* eslint-disable-next-line react/jsx-one-expression-per-line */ }
            Maintained by <a href="https://webinista.com/">Webinista, Inc.</a> a Los Angeles-based web developer and consultant.
          </i>
        </p>

      </footer>
    </>
  );
}

export default App;
